import React from "react";
import { Route } from "react-router-dom";
import PurchaseRecap from "../../../containers/modules/purchasing/purchase-recap";
import AccessControl from "../../../components/utilities/Class/AccessControl";

export default function PurchaseRecapRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="purchase-recap"
      index
      element={
        <AccessControl
          name={"Purchase Recap Request List"}
          auth={authUser}
          component={() => <PurchaseRecap />}
        />
      }
    ></Route>
  );
}
